<template>
  <div
    class="toast-layout"
    :style="{background:false?'none':'rgba(0, 0, 0, 0.3)'}"
    :class="{'toast-active':visible}"
  >
    <div class="toast-con recharge-con" :style="{minWidth:'868px'}">
      <div class="t-header">
        <span>{{typeName}}</span>
        <i class="iconfont icon-cuowu" @click="handleClick"></i>
      </div>
      <div class="pay-con">
        <div class="device">
          <div class="attr" :class="`attr${langauge}`">{{langauge==='en'?'Device: ':'开通设备：'}}</div>
          <div class="val">{{capacitychildName}}</div>
        </div>
        <template v-if="type==='renew'" >
          <div class="capacity">
            <div class="attr" :class="`attr${langauge}`">{{langauge==='en'?'Renew package: ':'续费套餐：'}}</div>
            <div class="val">{{activeItem.unit}}{{langauge==='en'?' plan':'套餐'}}</div>
          </div>
          <div class="capacity">
            <div class="attr" :class="`attr${langauge}`">{{langauge==='en'?'Select package period: ':'选择时限：'}}</div>
            <div class="val">
              <div class="tag tag-renew" v-for="(item,i) in qixianArr" :key="i" :class="{'tag-active':qixian===item.id}" @click="$emit('qixian',item.id)">
                <span class="tag-item">
                  <i :class="`icon-${item.icon}`" class="iconfont"></i>{{langauge==='en'?item.dateEn:item.date}}</span>
                <img :src="`${$cdn}images/tag-icon.png`" />
              </div>
            </div>
          </div>
        </template>

        <div v-else class="capacity">
          <div class="attr" :class="`attr${langauge}`">{{langauge==='en'?'Choose a plan: ':'选择容量：'}}</div>
          <div class="val">
            <div class="tag tag-active">
              <span class="year">{{activeItem.unit}}{{langauge==='en'?' plan':'套餐'}}</span>
              <span class="price">
                <i style="font-size:12px">{{country[capacitycountry]}} </i>{{capacitycountry===1?activeItem.dollarPrice:activeItem.price}}
                <span class="per"> / {{activeItem.description&&(langauge==='en'?ani[JSON.parse(activeItem.description)['期限单位']]:JSON.parse(activeItem.description)['期限单位'])}}</span>
              </span>
              <img :src="`${$cdn}images/tag-icon.png`" />
            </div>
          </div>
        </div>
        <div class="mid">
          <div class="attr" :class="`attr${langauge}`">{{langauge==='en'?'Payment method: ':'支付方式：'}}</div>
          <div class="body">
            <div
              class="pay-tag"
              :class="{'tag-active':paytype==='alipay'}"
              @click="paytype='alipay'"
              v-if="!capacitycountry"
            >
              <img :src="`${$cdn}images/ali-pay.png`" class="t-icon" alt />
              <span>{{langauge==='en'?'Alipay':'支付宝'}}</span>
              <img :src="`${$cdn}images/tag-icon.png`" class="t-click" alt />
            </div>
            <div
              class="pay-tag"
              :class="{'tag-active':paytype==='wechatPay'}"
              @click="paytype='wechatPay'"
              v-if="!capacitycountry"
            >
              <img :src="`${$cdn}images/wechat-pay.png`" class="t-icon" alt />
              <span>{{langauge==='en'?'Wechat':'微信支付'}}</span>
              <img :src="`${$cdn}images/tag-icon.png`" class="t-click" alt />
            </div>
          <div
              class="pay-tag paypal-con"
              :class="{'tag-active':paytype==='paypal'}"
              @click="paytype='paypal'"
              v-if="capacitycountry"
            >
              <img :src="`${$cdn}images/paypal.png`" class="t-icon" alt />
              <span>paypal</span>
              <img :src="`${$cdn}images/tag-icon.png`" class="t-click" alt />
              <form
                class="form-con"
                method="post"
                :action="`api/order/pay/paypal`"
              >
                <input v-model="currentId" type="text" name="orderId" />
                <input v-model="currentType" type="text" name="orderType" />
                <input type="submit" value="提交" />
              </form>
            </div>
          </div>
        </div>
        <div class="validity">
          <div class="attr" :class="`attr${langauge}`">{{langauge==='en'?'Storage Expiry: ':'容量期限：'}}</div>
          <div class="val" style="display:block">
            <p class="time">{{deadlineTime}}<span v-if="type!=='renew'&&delay>0">{{langauge==='en'?` (Package expiration: ${delay} days)`:`（延期：${delay}天）`}}</span></p>
            <p class="time" v-if="type!=='renew'&&delay>0">
              {{langauge==='en'?`Current package has not expired yet. After detailed calculations, the days left from the current package are added as ${delay} days to the upgraded package.`
              :`因原套餐未到期，经综合计算，新套餐延期${delay}天`}}</p>
          </div>
        </div>
        <div class="amount"  v-if="paytype !== 'paypal'">
          <div class="attr" :class="`attr${langauge}`">{{langauge==='en'?'Payables: ':'应付金额：'}}</div>
          <div class="val">
            <p class="a-price"><span>{{country[capacitycountry]}}</span> {{capacitycountry===1?activeItem.dollarPrice:activeItem.price}}</p>
            <template v-if="capacitycountry!==1">
              <img class="scanicon" :src="langauge==='en'?`${$cdn}images/scanicon-en.png`:`${$cdn}images/scanicon.png`" alt="">
              <img class="price-img" :src="response.src" alt="">
              <div class="dec">{{langauge==='en'?'Scan the ':'使用'}}<span style="color:#ff0000">{{payZH}}</span>{{langauge==='en'?' code and pay':'app扫码支付'}}</div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toastZH from '@/store/language/cn/toast'
import toastEN from '@/store/language/en/toast'
import { formatDate } from '@/util'

const ONEDAY = 86400000

let payTypes = {
  wechatPay: '微信',
  alipay: '支付宝',
  paypal: 'paypal'
}

let payTypesEn = {
  wechatPay: 'Wechat',
  alipay: 'Alipay',
  paypal: 'paypal'
}

let PAYSID = {
  'wechatPay': 0,
  'alipay': 1,
  'paypal': 2
}

let PAYSSTR = {
  0: 'wechatPay',
  1: 'alipay',
  2: 'paypal'
}

let ani = {
  '月': 'month',
  '年': 'year',
  '3个月': '3 mon.',
  '6个月': '6 mon.'
}
let country = {
  0: '￥',
  1: 'USD'
}

let typeName = {
  'renew': '立即续费',
  'recharge': '容量套餐'
}

let typeEnName = {
  'renew': 'Renew now',
  'recharge': 'Storage Plan'
}

let qixianType = {
  1: 1,
  12: 2,
  3: 3,
  6: 4
}

let qixianArr = [
  {
    id: 1,
    date: '1个月',
    dateEn: '1 mon.',
    icon: 'mouth'
  },
  {
    id: 3,
    date: '3个月',
    dateEn: '3 mon.',
    icon: '3mouth'
  },
  {
    id: 6,
    date: '6个月',
    dateEn: '6 mon.',
    icon: 'halfyear'
  },
  {
    id: 12,
    date: '1年',
    dateEn: '1 year',
    icon: 'year'
  }
]
export default {
  props: ['visible', 'capacitycount', 'type', 'capacityitem', 'deadline', 'capacitydetail', 'capacitycountry', 'capacitychildName'],
  computed: {
    deadlineTime () {
      return formatDate(this.delay * ONEDAY + this.deadline)
    },
    payZH () {
      return this.langauge === 'en' ? payTypesEn[this.paytype] : payTypes[this.paytype]
    },
    typeName () {
      return this.langauge === 'en' ? typeEnName[this.type] : typeName[this.type]
    },
    activeItem () {
      return this.capacityitem
    },
    qixian () {
      return this.capacityitem.month
    }

  },
  watch: {
    visible (newVal) {
      this.langauge = localStorage.getItem('language')
      this.toastCode = this.langauge === 'en' ? toastEN : toastZH
      if (!newVal) {
        clearInterval(this.t1)
        this.t1 = null
      }
    },
    activeItem (newVal) {
      if (newVal && this.capacitycount > 0) {
        this.pay()
      }
    },
    paytype () {
      this.pay()
    },
    qixian (newVal) {
      if (newVal) {
        this.getPrice()
      }
    }
  },
  data () {
    return {
      privilege: 'year',
      response: '',
      capacityType: [],
      delay: 0,
      t1: null,
      paytype: 'wechatPay',
      total: 0,
      currentId: '',
      currentType: 2,
      orderSn: '',
      country,
      langauge: localStorage.getItem('language'),
      toastCode: localStorage.getItem('language') === 'en' ? toastEN : toastZH,
      ani,
      qixianArr
    }
  },
  methods: {
    handleClick () {
      this.$emit('closePoint')
    },
    inverRequest () {
      clearInterval(this.t1)
      this.t1 = null
      this.t1 = setInterval(() => {
        this.queryOrderStatus()
      }, 5000)
    },
    async queryOrderStatus () {
      if (this.t1) {
        let params = {
          orderSn: this.orderSn,
          orderType: 2,
          payType: PAYSID[this.paytype]
        }
        let res = await this.$http
          .post('/user/order/queryOrderStatus', params, {
            headers: {
              token: localStorage.getItem('token')
            }
          })
        let response = res.data
        if (response.code === 0 && response.data) {
          this.t1 = null
          this.t1 && clearInterval(this.t1)
          this.$emit('closePoint', true)
        }
      }
    },
    async getPrice () {
      let params = {
        childName: this.capacitychildName || '',
        dateType: qixianType[this.qixian] || 1
      }
      let token = localStorage.getItem('token')

      let res = await this.$http
        .post('/user/order/getExpansionPrice', params, {
          headers: {
            token
          }
        })
      let data = res.data
      if (data.code !== 0) {
        return false
      }
      let list = data.data.skuList || []
      let deadLine = data.data.deadLine

      list.forEach(item => {
        if (item.unit === this.activeItem.unit) {
          this.$emit('renewItem', {item, deadLine})
        }
      })
    },
    async pay () {
      let {unit, skuSn} = this.activeItem
      let payTypeTemp = this.capacitycountry ? PAYSID['paypal'] : PAYSID[this.paytype]
      let params = {
        cameraId: this.capacitydetail.id,
        payType: payTypeTemp,
        unit: unit,
        unitSize: 1,
        years: 1,
        skuSn,
        abroad: this.capacitycountry
      }

      let res = await this.$http
        .post('/user/order/expansionOrder', params, {
          headers: {
            token: localStorage.getItem('token')
          }
        })

      let data = res.data
      if (data.code !== 0) {
        return this.$toast.show('error', this.toastCode['1'])
      }
      let {id, payType, orderSn, delay} = data.data
      this.delay = delay
      this.currentId = id
      this.orderSn = orderSn
      this.getCode(id, payType)
    },
    async getCode (id, payType) {
      let spaceId = this.type === 'renew' ? this.capacitydetail.spaceId : null
      if (payType !== 2) {
        let params = {
          orderId: id,
          orderType: 2,
          spaceId
        }
        let res = await this.$http
          .post(`/order/pay/${PAYSSTR[payType]}`, params, {
            headers: {
              token: localStorage.getItem('token')
            }
          })
        let response = res.data
        if (response.code !== 0) {
          return this.$toast.show('error', this.toastCode['2'], () => {
            this.t1 = null
            this.t1 && clearInterval(this.t1)
          })
        }
        this.response = response.data
        this.inverRequest()
      } else {
        this.t1 = null
        this.t1 && clearInterval(this.t1)
        if (this.paytype === 'paypal') {
          this.$toast.show('warn', this.toastCode['3'])
        }
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.t1)
    this.t1 = null
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>



// WEBPACK FOOTER //
// src/components/toast/capacityRecharge.vue